import { PHX_SIZE } from '../../constants';

export const PHX_MODAL_WIDTHS = {
  [PHX_SIZE.XS]: 320,
  [PHX_SIZE.SM]: 400,
  [PHX_SIZE.MD]: 480,
  [PHX_SIZE.LG]: 560,
  [PHX_SIZE.XL]: 640,
  auto: 'auto',
} as const